<section class="widget-page">
  <div class="d-flex align-items-center gap-3 mb-3">
    <div class="d-flex align-items-center gap-2">
      <h6 class="mb-0 page-title" i18n>Calendar Widget</h6>
      <app-page-help [articleId]="'iszbccfr9x'" videoId="-"></app-page-help>
    </div>
    <div class="flex-fill"></div>
    <a routerLink="/widgets" class="btn btn-secondary-primary">
      <i class="far fa-chevron-left"></i>
      <ng-container i18n>Back to Widgets</ng-container>
    </a>
  </div>

  <div class="main-content">
    <div class="container-box details-box">
      <div class="box-body">
        <div class="row">
          <div class="col-lg-6 col-xl-5">
            <div class="widget-holder p-3">
              <div class="alert alert-secondary-info">
                <i class="cs-icon cs-icon-info-circle alert-icon"></i>
                <div class="aler-content" i18n>
                  Calendar widget allows you to display booking availability on any website. Simply copy and paste the
                  widget code to your webpage.
                </div>
              </div>

              <form [formGroup]="form">
                <div class="clearfix widget-box">
                  <h4 class="title">
                    <ng-container i18n>1. Select a Rental</ng-container> <span class="red-star">*</span>
                    <app-info-icon
                      i18n-tooltipText
                      tooltipText="The calendar widget is rental specific. Only one rental can be selected in this configuration."
                    ></app-info-icon>
                  </h4>
                  <div class="row">
                    <div class="col-sm-12">
                      <app-rental-select
                        [multiple]="false"
                        [ctrl]="form.get('rentalId')"
                        i18n-placeholder
                        placeholder="Rental"
                      ></app-rental-select>
                    </div>
                  </div>
                </div>

                <!-- ***if want to disable/pointer-event:none for this section***
                  <div class="clearfix widget-box disabled"> -->

                <div class="clearfix widget-box">
                  <h4 class="title">
                    <ng-container i18n>2. Widget Style</ng-container>
                    <app-info-icon
                      i18n-tooltipText
                      tooltipText="Your changes can be viewed in the widget preview to the right of this configuration menu."
                    ></app-info-icon>
                  </h4>
                  <div class="row">
                    <div class="col-sm-6">
                      <mat-form-field2 class="mat-block">
                        <input
                          matInput
                          [value]="form.get('availableColor').value"
                          i18n-placeholder
                          placeholder="Available Color"
                          [colorPicker]="form.get('availableColor').value"
                          [cpOutputFormat]="'hex'"
                          [cpPosition]="'bottom'"
                          (colorPickerChange)="onColorSelected('availableColor', $event)"
                          required
                        />
                        <mat-icon
                          matSuffix
                          fontSet="fas"
                          fontIcon="fa-circle"
                          class="color-picker-value-indicator"
                          [style.color]="form.get('availableColor').value"
                        ></mat-icon>
                      </mat-form-field2>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      <mat-form-field2 class="mat-block">
                        <mat-select
                          i18n-placeholder
                          placeholder="Select number of visible months"
                          formControlName="calendarNum"
                          required
                        >
                          <mat-option *ngFor="let n of calendarsNumOpts" [value]="n">
                            {{ n }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field2>
                    </div>
                    <div class="col-sm-6">
                      <mat-form-field2 class="mat-block">
                        <input
                          matInput
                          [value]="form.get('unavailableColor').value"
                          i18n-placeholder
                          placeholder="Unavailable Color"
                          [colorPicker]="form.get('unavailableColor').value"
                          [cpOutputFormat]="'hex'"
                          [cpPosition]="'bottom'"
                          (colorPickerChange)="onColorSelected('unavailableColor', $event)"
                          required
                        />
                        <mat-icon
                          matSuffix
                          fontSet="fas"
                          fontIcon="fa-circle"
                          class="color-picker-value-indicator"
                          [style.color]="form.get('unavailableColor').value"
                        ></mat-icon>
                      </mat-form-field2>
                    </div>
                    <div class="col-sm-6">
                      <mat-form-field2 class="mat-block">
                        <mat-select placeholder="Font Family" i18n-placeholder formControlName="fontFamily" required>
                          <mat-option *ngFor="let n of fontFamilies" [value]="n">
                            {{ n }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field2>
                    </div>
                    <div class="col-sm-6">
                      <mat-form-field2 class="mat-block">
                        <mat-select placeholder="Font Size" i18n-placeholder formControlName="fontSize" required>
                          <mat-option *ngFor="let n of fontSizeOpts" [value]="n">
                            {{ n }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field2>
                    </div>
                  </div>
                </div>

                <div class="clearfix widget-box">
                  <div class="alert alert-dark">
                    <p i18n>Widget Code</p>
                    <p class="widget-code" [innerText]="widgetCode"></p>
                  </div>
                </div>

                <div class="clearfix widget-box">
                  <h4 class="title" i18n>3. Copy and paste the desired widget code onto your website.</h4>
                  <div class="row">
                    <div class="col-sm-12 btn-holder">
                      <button
                        type="button"
                        class="btn btn-secondary-light"
                        [disabled]="!widgetCode"
                        ngxClipboard
                        [cbContent]="widgetCode"
                        (cbOnSuccess)="onCopied($event)"
                      >
                        <span class="fal fa-copy"></span>
                        <ng-container i18n>copy code</ng-container>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="col-lg-6 col-xl-7">
            <div class="widget-preview d-flex align-items-center flex-column h-100 p-3">
              <h5 class="title text-light" i18n>Widget Preview</h5>

              <div class="preview-box flex-fill w-100">
                <iframe
                  [srcdoc]="trustedWidgetCode"
                  frameborder="0"
                  *ngIf="trustedWidgetCode"
                  class="w-100 h-100"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
